import Parse from "parse";

Parse.initialize("opendashfit");
Parse.serverURL = "https://crowdwater.fit.fraunhofer.de/parse";
